import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import ListGruposAcoesForm from "./ListGruposAcoesForm";

const ListGruposSecoesForm = ({ indexPerm, control, register,getValues, setValue, errors }) => {
    const { fields, remove, append } = useFieldArray({
        control,
        name: `permissoes.${indexPerm}.secoes`
    });

      //console.log(fields)
    return (
        <>
            {fields?.map((item, index) => (
                <>
                <Row key={index}> 

                    <Col>
                        <label>{item.nome}</label>
                    </Col>
                    <Form.Group as={Col}>
                         <ListGruposAcoesForm indexPerm={indexPerm} indexSecoes={index} {...{ control, register,  getValues, setValue, errors }}/>
                    </Form.Group>
                </Row>
                </>
            ))}

        </>
    )
}

export default ListGruposSecoesForm;